import { gql } from "@apollo/client";

const infraAlignment_fields = `
InfraAlignmentId
Name
`;
const infralines_fields = `
InfraLines {
  InfraLineId
  Length
  Chord
  Delta
  Dir
  DirStart
  InfraLineType {
    Name
  }
  Start {
    x
    y
    z
    WGS84_lat
    WGS84_lon
    InfraPointType {
      Name
    }
  }
  End {
    x
    y
    z
    WGS84_lat
    WGS84_lon
    InfraPointType {
      Name
    }
  }
  Center {
    x
    y
    z
    WGS84_lat
    WGS84_lon
    InfraPointType {
      Name
    }
  }
  DirEnd
}`;

export const GET_INFRA_ALIGNMENT_BY_ID = gql(
  `
query infraAlignmentById($InfraAlignmentId: Int!) { 
  infraAlignmentById(
    data:{
      InfraAlignmentId: $InfraAlignmentId
    }) {` +
    infraAlignment_fields +
    infralines_fields +
    `}
  }
`
);

export const GET_INFRA_ALIGNMENT_BY_EPICID = gql(
  `
query infraAlignmentsByEpicId($EpicId: Int!) { 
  infraAlignmentsByEpicId(
    data:{
      EpicId: $EpicId
    }) {` +
    infraAlignment_fields +
    infralines_fields +
    `}
  }
`
);

export const GET_INFRA_ALIGNMENTINFORMATION_BY_EPICID = gql(
  `
query infraAlignmentsByEpicId($EpicId: Int!) { 
  infraAlignmentsByEpicId(
    data:{
      EpicId: $EpicId
    }) {` +
    infraAlignment_fields +
    `}
  }
`
);

export const GET_INFRA_ALIGNMENTS = gql(
  `
query infraAlignments { 
  infraAlignments {` +
    infraAlignment_fields +
    `}
}
`
);

export const GET_INFRA_ALIGNMENTSDATA = gql`
  query infraAlignments {
    infraAlignments {
      InfraAlignmentId
      Name
      InfraLines {
        InfraLineId
        Length
        Chord
        Delta
        Dir
        DirStart
        InfraLineType {
          Name
        }
        Start {
          x
          y
          z
          WGS84_lat
          WGS84_lon
          InfraPointType {
            Name
          }
        }
        End {
          x
          y
          z
          WGS84_lat
          WGS84_lon
          InfraPointType {
            Name
          }
        }
        Center {
          x
          y
          z
          WGS84_lat
          WGS84_lon
          InfraPointType {
            Name
          }
        }
        DirEnd
      }
    }
  }
`;

export const DELETE_INFRA_ALIGNMENT = gql(`
mutation deleteInfraAlignment($InfraAlignmentId: Int!) {
  deleteInfraAlignment(data: {
      InfraAlignmentId: $InfraAlignmentId
    })
}`);

export const CREATE_INFRA_ALIGNMENT = gql(
  `
mutation createAlignment($EpicId: Int!, $Name: String!, $InfraLines: [CreateInfraLineInputType!]) {
	createAlignment(data: {
    EpicId: $EpicId
    Name: $Name
    InfraLines: $InfraLines
	}){` +
    infraAlignment_fields +
    infralines_fields +
    `}
  } 
`
);
